import React from 'react';
import { Link } from 'react-router-dom';
// import AlertaContext from '../../context/alertas/alertaContext';
// import AuthContext from '../../context/autenticacion/authContext';
import Footer from './layout/Footer';
import Navbar from './layout/Navbar';
import cdmx from './cdmx.jpg'



const Home = () => {

  return (
    <div >
      <Navbar />
      <section className='lg:items-center text-center pt-16'>
        <img src={cdmx} height="1000" width="1400" className='object-cover opacity-50 pt-3 z-10 bg-cover bg-center relative'></img>
        <p id='p-img' className="text-black text-xl my-16 mb-10 px-10 font-bold absolute">FinnMx</p>
      </section>
      <section className='px-10'>
        <div className=" border-b border-t border-b-2 border-teal-500 my-12 lg:my-40">
          <h2 className='text-center text-2xl py-4 lg:min-w-8xl lg:my-20 font-bold'>¿Qué hace? </h2>
        </div>
        <p className="text-gray-800 text-xl mt-16 text-base">FinnMx te ayuda a tener mejor visibilidad de instrumentos financieros donde puedes invertir tu dinero en base a tu perfil.  </p>         
      </section>

      <section className='px-10'>
        <div className=" border-b border-t border-b-2 border-teal-500 my-12 lg:my-40">
          <h2 className='text-center text-2xl py-4 lg:min-w-8xl lg:my-20 font-bold'>¿Cómo lo hace? </h2>
        </div>

        <p className="text-xl mt-16 mb-10 text-base border bg-black text-white p-1">1. Información financiera </p>
        <p className="text-gray-800 text-md text-center"> Ingresa al simulador y completa todos los datos del formulario para que podamos analizar tu perfil.  </p>
       
        <p className="text-xl mt-16 mb-10 text-base border bg-black text-white p-1">2. Modelo financiero </p>
        <p className="text-gray-800 text-md"> Nuestro modelo te dirá los instrumentos financieros que mejor se ajustena tu perfil. </p> 

        <p className="text-xl mt-16 mb-10 text-base border bg-black text-white p-1">3. Invierte</p>
        <p className="text-gray-800 text-md"> Infórmate, continúa investigando y ¡ comienza a invertir !</p>
          
        <div className="xl:flex items-center py-8 my-12 text-center ">



        <div className="text-center">
          <button className="shadow bg-black text-white font-bold py-4 px-12 rounded-full text-lg transition duration-500 ease-in-out hover:bg-teal-500 hover:text-white transform hover:-translate-y-1 hover:scale-110" type='button'><Link to={'/savings-info'}>Ingresar</Link></button>

        </div>
          {/* <div className="xl:w-1/3"/> */}
        </div>
      </section>
      <Footer />

    </div>
  );
}

export default Home;

